// ===================================================
// CONTRATO DIGITAL
// ===================================================
function switchCtTab(idx){
  document.querySelectorAll('.ct-tab').forEach((t,i)=>{
    const active=i===idx;
    t.style.color=active?'var(--accent)':'var(--muted)';
    t.style.borderBottom=active?'2px solid var(--accent)':'2px solid transparent';
    t.style.fontWeight=active?'600':'500';
  });
  document.querySelectorAll('.ct-panel').forEach((p,i)=>p.style.display=i===idx?'':'none');
}

function atualizarCtSaldo(){
  const val=parseFloat(document.getElementById('ct-valor')?.value)||0;
  const ent=parseFloat(document.getElementById('ct-entrada')?.value)||0;
  const saldoEl=document.getElementById('ct-saldo');
  if(saldoEl)saldoEl.value=(val-ent).toFixed(2);
}
// Cliente que paga tudo no ato do pedido: sem saldo futuro, sem prazo/forma de pagamento do saldo
function aplicarEstadoCtPagamentoIntegral(chk){
  const entradaEl=document.getElementById('ct-entrada'),saldoFormaEl=document.getElementById('ct-pagto-saldo'),prazoEl=document.getElementById('ct-pagto-prazo'),label=document.getElementById('ct-label-entrada'),labelForma=document.getElementById('ct-label-forma-entrada');
  if(entradaEl)entradaEl.readOnly=!!chk;
  if(saldoFormaEl)saldoFormaEl.disabled=!!chk;
  if(prazoEl)prazoEl.disabled=!!chk;
  if(label)label.textContent=chk?'Valor pago no pedido (R$)':'Entrada / sinal (R$)';
  if(labelForma)labelForma.textContent=chk?'Forma de pagamento':'Forma de pagamento do sinal';
}
// Preenche rapidamente o campo de forma de pagamento a partir de uma lista padrão
// (Pix, transferência, cartão à vista/parcelado, boleto à vista/com prazo, etc.) — o texto
// continua editável depois, para detalhar parcelas, prazo em dias etc.
function aplicarFormaPagamentoCt(selectEl,inputId){
  const v=selectEl.value;
  const el=document.getElementById(inputId);
  if(!v||!el)return;
  el.value=v;
  selectEl.value='';
  el.focus();
}
function toggleCtPagamentoIntegral(){
  const chk=document.getElementById('ct-pagamento-integral')?.checked;
  aplicarEstadoCtPagamentoIntegral(chk);
  if(chk){
    const valor=parseFloat(document.getElementById('ct-valor')?.value)||0;
    document.getElementById('ct-entrada').value=valor.toFixed(2);
    document.getElementById('ct-pagto-saldo').value='';
  }
  atualizarCtSaldo();
}

let _ctMateriais=[];
const CT_ESPESSURAS=['2 cm','3 cm','2 e 3 cm','engrossada com saia colada','conforme projeto'];
const CT_ACABAMENTOS=['polido','levigado','escovado','flameado','apicoado','jateado','acetinado','conforme projeto'];
const CT_BORDAS=['reta simples','bisotê','meia cana','boleada','chanfrada','45° / meia esquadria','peito de pombo','pingadeira','conforme projeto'];
function addCtMaterialRow(r){_ctMateriais.push(r||{ambiente:'',material:'',espessura:'2 cm',acabamento:'polido',borda:'reta simples'});renderCtMateriais()}
function setCtMaterial(i,k,v){const r=_ctMateriais[i];if(!r)return;r[k]=v}
function removeCtMaterialRow(i){_ctMateriais.splice(i,1);renderCtMateriais()}
function renderCtMateriais(){
  const el=document.getElementById('ct-materiais-list');if(!el)return;
  el.innerHTML=_ctMateriais.length?_ctMateriais.map((r,i)=>`<div style="display:grid;grid-template-columns:1.1fr 1.3fr 1fr 1fr 1fr 30px;gap:6px;align-items:center">
    <input class="si" placeholder="Ambiente" value="${escapeHtml(r.ambiente||'')}" oninput="setCtMaterial(${i},'ambiente',this.value)">
    <input class="si" placeholder="Ex.: Quartzo Taj Mahal" value="${escapeHtml(r.material||'')}" oninput="setCtMaterial(${i},'material',this.value)">
    <select class="si" onchange="setCtMaterial(${i},'espessura',this.value)">${CT_ESPESSURAS.map(o=>`<option ${r.espessura===o?'selected':''}>${o}</option>`).join('')}</select>
    <select class="si" onchange="setCtMaterial(${i},'acabamento',this.value)">${CT_ACABAMENTOS.map(o=>`<option ${r.acabamento===o?'selected':''}>${o}</option>`).join('')}</select>
    <select class="si" onchange="setCtMaterial(${i},'borda',this.value)">${CT_BORDAS.map(o=>`<option ${r.borda===o?'selected':''}>${o}</option>`).join('')}</select>
    <button type="button" class="btn btn-danger btn-sm" onclick="removeCtMaterialRow(${i})">×</button>
  </div>`).join(''):'<div style="font-size:11px;color:var(--muted)">Nenhum ambiente lançado. Clique em "Adicionar ambiente".</div>';
}
function openContratoForm(pedidoId){
  const p=DB.get('pedidos').find(x=>x.id===pedidoId);
  if(!p){toast('Pedido não encontrado','error');return;}
  const c=DB.get('clientes').find(x=>x.id===p.clienteId)||{};
  const cfg=CACHE.config||{};
  // Reset tabs
  switchCtTab(0);
  document.getElementById('ct-pedido-id').value=pedidoId;
  document.getElementById('contrato-modal-title').textContent=`Contrato — Pedido #${p.num||'?'}`;
  // TAB 0: Contratante
  document.getElementById('ct-nome').value=c.nome||p.cliente||'';
  document.getElementById('ct-cpf').value=c.cpfcnpj||p.cpfcnpj||'';
  document.getElementById('ct-rg').value=rgLegadoValor(c);
  document.getElementById('ct-email').value=c.email||p.email||'';
  // Qualificação do contratante usa cadastro do cliente; endereço da obra fica separado.
  const endRua=c.endereco||c.end||'';
  document.getElementById('ct-end-rua').value=endRua;
  document.getElementById('ct-end-numero').value=c.num||'';
  document.getElementById('ct-end-complemento').value=c.comp||'';
  document.getElementById('ct-end-bairro').value=c.bairro||'';
  document.getElementById('ct-end-cidade').value=c.cidade||'';
  document.getElementById('ct-end-cep').value=c.cep||'';
  document.getElementById('ct-end-obra').value=p.end||p.enderecoObra||'';
  document.getElementById('ct-doc-tipo').value='';
  document.getElementById('ct-doc-numero').value='';
  document.getElementById('ct-doc-nome').textContent='';
  document.getElementById('ct-doc-preview').style.display='none';
  document.getElementById('ct-ocr-btn').style.display='none';
  document.getElementById('ct-ocr-status').style.display='none';
  window._ctDocDataUrl=null;
  // TAB 1: Materiais — um material por ambiente (evita aplicar o mesmo material a todos os ambientes)
  {
    const grupos=[];
    (p.itens||[]).forEach(it=>{
      const amb=String(it.ambiente||'').trim()||'Geral';
      const mat=String(it.material||'').trim();
      let g=grupos.find(x=>x.ambiente===amb&&x.material===mat);
      if(!g){g={ambiente:amb,material:mat,espessura:it.espessura||'2 cm',acabamento:it.acabamento||'polido',borda:it.borda||'reta simples'};grupos.push(g);}
    });
    _ctMateriais=grupos.length?grupos:[{ambiente:p.desc?String(p.desc).split(' ').slice(0,4).join(' '):'',material:p.material||'',espessura:'2 cm',acabamento:'polido',borda:'reta simples'}];
    renderCtMateriais();
  }
  // Auto-fill saias/frontão/espelhos from sub-peças dos itens do pedido
  {const allSp=(p.itens||[]).flatMap(it=>(it.pecas||[]).map(sp=>({...sp,_p:it})));
  ['ct-saia-frontal','ct-saia-lateral','ct-frontao','ct-rodaborda','ct-espelho','ct-area-molhada'].forEach(id=>{const el=document.getElementById(id);if(el)el.checked=false;});
  ['ct-saia-frontal-alt','ct-saia-lateral-alt','ct-frontao-alt','ct-rodaborda-alt','ct-espelho-alt'].forEach(id=>{const el=document.getElementById(id);if(el)el.value='';});
  const mSp=(kws)=>allSp.find(sp=>kws.some(kw=>String(sp.tipo||'').toLowerCase().includes(kw)));
  const setChk=(chkId,altId,kws)=>{const sp=mSp(kws);if(!sp)return;const el=document.getElementById(chkId);if(el)el.checked=true;const alt=document.getElementById(altId);if(alt&&geoNum(sp.comp))alt.value=geoNum(sp.comp);};
  setChk('ct-saia-frontal','ct-saia-frontal-alt',['saia frontal','frontal']);
  setChk('ct-saia-lateral','ct-saia-lateral-alt',['saia lateral','lateral']);
  setChk('ct-frontao','ct-frontao-alt',['frontão','frontao']);
  setChk('ct-rodaborda','ct-rodaborda-alt',['rodaborda','rodabanca','rodapé','rodape']);
  setChk('ct-espelho','ct-espelho-alt',['espelho','backsplash']);}
  // TAB 2: Financeiro — detecta se o pedido já foi pago integralmente em uma única parcela no ato
  document.getElementById('ct-valor').value=p.valor||'';
  const pagamentosPedido=(p.pagamentos||[]).filter(r=>geoNum(r.valor)>0);
  const pagoIntegralNoPedido=pagamentosPedido.length===1&&(Number(p.valor)||0)>0&&geoNum(pagamentosPedido[0].valor)>=(Number(p.valor)||0)-0.01;
  const chkIntegral=document.getElementById('ct-pagamento-integral');
  if(chkIntegral)chkIntegral.checked=pagoIntegralNoPedido;
  document.getElementById('ct-entrada').value=pagoIntegralNoPedido?(p.valor||0):(p.entrada||'');
  document.getElementById('ct-pagto-entrada').value=pagoIntegralNoPedido?(()=>{const r=pagamentosPedido[0],parc=Math.max(1,parseInt(r.parcelas)||1);return formaPagamentoLegivel(r.forma||'')+(parc>1?` em ${parc}x`:'')})():'';
  document.getElementById('ct-pagto-saldo').value=pagoIntegralNoPedido?'':(p.pagto||'');
  aplicarEstadoCtPagamentoIntegral(pagoIntegralNoPedido);
  atualizarCtSaldo();
  // TAB 3: Prazo
  const prazoNum=p.entrega?Math.max(1,Math.round((new Date(p.entrega+'T12:00')-new Date())/(1000*60*60*24))):30;
  document.getElementById('ct-prazo-dias').value=Math.min(120,Math.max(1,prazoNum));
  // TAB 4: Obs
  document.getElementById('ct-data-contrato').value=today();
  document.getElementById('ct-cidade-contrato').value=cfg.cidade||'Campinas';
  document.getElementById('ct-obs-adicionais').value=p.obsTec||p.obs||'';
  // Restaurar rascunho salvo anteriormente (sobrescreve os valores padrão)
  if(p.contratoRascunho){
    const r=p.contratoRascunho;
    const CT_FIELDS=['ct-cidade-contrato','ct-condominio','ct-cpf','ct-cuba','ct-data-contrato','ct-doc-numero','ct-doc-tipo','ct-email','ct-end-andar','ct-end-bairro','ct-end-cep','ct-end-cidade','ct-end-complemento','ct-end-numero','ct-end-obra','ct-end-rua','ct-entrada','ct-espelho-alt','ct-estado-civil','ct-frontao-alt','ct-icamento','ct-inclusos','ct-instalacao','ct-nacionalidade','ct-nome','ct-obs-adicionais','ct-obs-material','ct-pagto-entrada','ct-pagto-prazo','ct-pagto-saldo','ct-prazo-base','ct-prazo-dias','ct-ralo','ct-rodaborda-alt','ct-saia-frontal-alt','ct-saia-lateral-alt','ct-saldo','ct-sifao','ct-suporte','ct-torneira','ct-valor'];
    const CT_CHECKS=['ct-area-molhada','ct-canal-molhado','ct-escorredor','ct-espelho','ct-frontao','ct-furo-dosador','ct-furo-filtro','ct-furo-torneira','ct-pagamento-integral','ct-recorte-cooktop','ct-recorte-cuba','ct-recorte-lixeira','ct-rodaborda','ct-saia-frontal','ct-saia-lateral'];
    CT_FIELDS.forEach(id=>{const el=document.getElementById(id);if(el&&r[id]!=null)el.value=r[id];});
    CT_CHECKS.forEach(id=>{const el=document.getElementById(id);if(el&&r[id]!=null)el.checked=r[id];});
    aplicarEstadoCtPagamentoIntegral(document.getElementById('ct-pagamento-integral')?.checked);
    if(r.materiaisPorAmbiente&&r.materiaisPorAmbiente.length){_ctMateriais=JSON.parse(JSON.stringify(r.materiaisPorAmbiente));renderCtMateriais();}
    const dt=r._savedAt?new Date(r._savedAt).toLocaleDateString('pt-BR'):'';
    toast(`Rascunho carregado${dt?' ('+dt+')':''}`,'info');
  }
  openModal('modal-contrato');
}

async function salvarRascunhoContrato(){
  const pedidoId=document.getElementById('ct-pedido-id')?.value;
  if(!pedidoId){toast('Nenhum pedido vinculado','error');return;}
  const CT_FIELDS=['ct-cidade-contrato','ct-condominio','ct-cpf','ct-cuba','ct-data-contrato','ct-doc-numero','ct-doc-tipo','ct-email','ct-end-andar','ct-end-bairro','ct-end-cep','ct-end-cidade','ct-end-complemento','ct-end-numero','ct-end-obra','ct-end-rua','ct-entrada','ct-espelho-alt','ct-estado-civil','ct-frontao-alt','ct-icamento','ct-inclusos','ct-instalacao','ct-nacionalidade','ct-nome','ct-obs-adicionais','ct-obs-material','ct-pagto-entrada','ct-pagto-prazo','ct-pagto-saldo','ct-prazo-base','ct-prazo-dias','ct-ralo','ct-rodaborda-alt','ct-saia-frontal-alt','ct-saia-lateral-alt','ct-saldo','ct-sifao','ct-suporte','ct-torneira','ct-valor'];
  const CT_CHECKS=['ct-area-molhada','ct-canal-molhado','ct-escorredor','ct-espelho','ct-frontao','ct-furo-dosador','ct-furo-filtro','ct-furo-torneira','ct-pagamento-integral','ct-recorte-cooktop','ct-recorte-cuba','ct-recorte-lixeira','ct-rodaborda','ct-saia-frontal','ct-saia-lateral'];
  const r={_savedAt:new Date().toISOString(),materiaisPorAmbiente:JSON.parse(JSON.stringify(_ctMateriais))};
  CT_FIELDS.forEach(id=>{const el=document.getElementById(id);if(el)r[id]=el.value;});
  CT_CHECKS.forEach(id=>{const el=document.getElementById(id);if(el)r[id]=el.checked;});
  const pedidos=DB.get('pedidos');const idx=pedidos.findIndex(p=>p.id===pedidoId);
  if(idx<0){toast('Pedido não encontrado','error');return;}
  pedidos[idx].contratoRascunho=r;
  await DB.set('pedidos',pedidos);
  toast('Rascunho salvo ✓');
}

function _buildContratoHTML(data){
  const {contratante,contratada,objeto,materiais,financeiro,prazo,local,adicionais,dataContrato,cidadeContrato,proposta={},contratuais={}}=data;
  const nomeEmpresa=contratada.nome;
  const fmt2=v=>v!=null?new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(v):'—';
  const pctEntrada=financeiro.valor>0?Math.round((financeiro.entrada/financeiro.valor)*100):50;
  const enderecoInstalacao=local.enderecoObra||contratante.enderecoCompleto;
  const inclusos=adicionais.inclusos?`\n\nItens expressamente incluídos além do padrão:\n${adicionais.inclusos}`:'';
  const obsAdicionais=adicionais.texto?`\n\n<div class="clausula"><h3>23. Disposições Adicionais</h3><p>a. As partes acordam ainda as seguintes condições específicas: ${adicionais.texto}</p></div>`:'';
  const propostaRef=proposta.numero?`Proposta nº ${proposta.numero}${proposta.data?`, emitida em ${proposta.data}`:''}${proposta.versao?`, versão ${proposta.versao}`:''}`:'proposta técnica e comercial vinculada a este pedido';
  const garantiaAdicional=contratuais.garantiaContratual?` Eventual garantia contratual adicional será de ${contratuais.garantiaContratual} e complementará, sem substituir, a garantia legal.`:'';
  const canalAssistencia=contratuais.canalAssistencia||'canal informado pela CONTRATADA';
  const comarcaForo=contratuais.comarcaForo||cidadeContrato||'Campinas/SP';
  const logoContrato=contratada.logoUrl||'';
  const telefoneContrato=tel=>{
    const raw=String(tel||'').trim();
    const d=raw.replace(/\D/g,'');
    if(d.length===11)return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
    if(d.length===10)return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
    return raw;
  };
  const enderecoEmpresa=[contratada.endereco,contratada.cidade].filter(Boolean).join(' · ');
  const contatoEmpresa=[telefoneContrato(contratada.tel),contratada.email].filter(Boolean).join(' · ');
  const representanteContratada=contratada.representante||{};
  const nomeRepresentanteContratada=representanteContratada.nome||'';
  const cargoRepresentanteContratada=representanteContratada.cargo||'Representante legal';

  return `<!DOCTYPE html><html><head><meta charset="utf-8">
<title>Contrato — ${contratante.nome}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
@page{size:A4;margin:16mm 18mm 20mm}
html{background:#f3f0ea}
body{font-family:Arial,sans-serif;font-size:13px;color:#1a1a1a;padding:52px 58px 78px;width:210mm;min-height:297mm;margin:0 auto;line-height:1.65;background:#fff;position:relative}
h1{font-size:15px;font-weight:700;text-align:center;text-transform:uppercase;letter-spacing:.08em;margin-bottom:6px;line-height:1.4}
.subtitle{text-align:center;font-size:12px;color:#444;margin-bottom:32px}
.cover-page{min-height:calc(297mm - 130px);display:flex;flex-direction:column;justify-content:center;text-align:center;break-after:page;page-break-after:always;padding:30px 18px;position:relative;z-index:1}
.cover-core{transform:translateY(-8mm)}
.cover-logo{width:142px;height:92px;object-fit:contain;margin:0 auto 18px;display:block}
.cover-kicker{font-size:11px;text-transform:uppercase;letter-spacing:.28em;color:#9b7624;margin-bottom:18px}
.cover-company{font-size:26px;text-transform:uppercase;letter-spacing:.18em;font-weight:700;color:#171717;line-height:1.35;margin-bottom:12px}
.cover-rule{width:118px;height:2px;background:#b9872f;margin:22px auto}
.cover-title{font-size:17px;text-transform:uppercase;letter-spacing:.1em;font-weight:700;line-height:1.55;max-width:640px;margin:0 auto;color:#222}
.cover-company-strip{position:absolute;left:18px;right:18px;bottom:30px;padding-top:16px;font-size:11px;color:#4c4c4c;letter-spacing:.06em;text-transform:uppercase}
.contract-document{position:relative;z-index:1}
.contract-header{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin-bottom:22px;padding-bottom:14px}
.contract-brand{display:flex;align-items:center;gap:12px;min-width:0}
.contract-logo{width:86px;height:52px;object-fit:contain;flex:0 0 auto}
.contract-brand-name{font-size:12px;text-transform:uppercase;letter-spacing:.16em;font-weight:700;line-height:1.4;color:#222}
.contract-meta{text-align:right;font-size:10.5px;color:#555;line-height:1.55;min-width:170px}
.empresa-info{border:1px solid #ddd3bd;background:#fbfaf6;border-radius:6px;padding:14px 16px;margin:20px 0 24px;break-inside:avoid;page-break-inside:avoid}
.empresa-info h2{font-size:11px;text-transform:uppercase;letter-spacing:.12em;margin-bottom:10px;color:#7b5a16}
.empresa-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 18px}
.empresa-field{font-size:11.5px;color:#333;line-height:1.45}
.empresa-field small{display:block;font-size:9.5px;text-transform:uppercase;letter-spacing:.08em;color:#777;margin-bottom:2px}
.clausula{margin:18px 0;break-inside:auto;page-break-inside:auto}
.clausula h3{font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px;color:#111;border-bottom:1px solid #ddd;padding-bottom:4px}
.clausula p,.clausula li{font-size:13px;color:#222;margin-bottom:5px;text-align:justify;text-align-last:left;text-justify:inter-word;hyphens:auto;overflow-wrap:break-word}
.clausula ol,.clausula ul{padding-left:22px}
.clausula li{margin-bottom:3px}
.partes{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin:20px 0 28px;background:#f7f7f7;border-radius:6px;padding:16px 20px;border:1px solid #ddd}
.parte-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:#555;margin-bottom:4px}
.parte-nome{font-size:14px;font-weight:700;margin-bottom:6px}
.parte-info{font-size:12px;color:#444;line-height:1.7}
.assinaturas{margin-top:72px;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:40px}
.assin-bloco{text-align:center;min-height:132px}
.assin-linha{border-top:1px solid #111;padding-top:10px;margin:72px auto 0;width:100%;font-size:12px;line-height:1.6}
.plataforma-final{margin-top:28px;padding-top:8px;font-size:9.5px;color:#777;text-align:center;break-inside:avoid;page-break-inside:avoid}
@media print{html,body{background:#fff}body{padding:0;width:auto;min-height:auto;margin:0;max-width:none}.cover-page{min-height:calc(297mm - 36mm);padding:0}.clausula{break-inside:auto;page-break-inside:auto}.clausula h3{break-after:avoid-page;page-break-after:avoid}.clausula p,.clausula ol,.clausula ul{orphans:3;widows:3}.partes,.assinaturas,.empresa-info{break-inside:avoid;page-break-inside:avoid}}
</style>
</head><body>
<section class="cover-page">
  <div class="cover-core">
    ${logoContrato?`<img class="cover-logo" src="${escapeHtml(logoContrato)}" alt="${escapeHtml(nomeEmpresa)}" onerror="this.style.display='none'">`:''}
    <div class="cover-kicker">Contrato Particular</div>
    <div class="cover-company">${escapeHtml(nomeEmpresa)}</div>
    <div class="cover-rule"></div>
    <div class="cover-title">Prestação de Serviços de Marmoraria<br>com Fornecimento de Material e Instalação</div>
  </div>
  <div class="cover-company-strip">
    ${escapeHtml([enderecoEmpresa,contatoEmpresa].filter(Boolean).join(' | ')||nomeEmpresa)}
  </div>
</section>
<main class="contract-document">
<div class="contract-header">
  <div class="contract-brand">
    ${logoContrato?`<img class="contract-logo" src="${escapeHtml(logoContrato)}" alt="${escapeHtml(nomeEmpresa)}" onerror="this.style.display='none'">`:''}
    <div>
      <div class="contract-brand-name">${escapeHtml(nomeEmpresa)}</div>
      <div style="font-size:10.5px;color:#666;text-transform:uppercase;letter-spacing:.08em">Instrumento particular</div>
    </div>
  </div>
  <div class="contract-meta">
    ${proposta.numero?`Proposta nº ${escapeHtml(String(proposta.numero))}<br>`:''}
    ${dataContrato?`Data: ${escapeHtml(dataContrato)}<br>`:''}
    ${cidadeContrato?`Local: ${escapeHtml(cidadeContrato)}`:''}
  </div>
</div>
<h1>Contrato de Prestação de Serviços de Marmoraria<br>com Fornecimento de Material e Instalação</h1>
<p class="subtitle">Instrumento particular de prestação de serviços</p>

<section class="empresa-info">
  <h2>Informações empresariais da contratada</h2>
  <div class="empresa-grid">
    <div class="empresa-field"><small>Nome fantasia</small>${escapeHtml(contratada.nomeFantasia||nomeEmpresa)}</div>
    <div class="empresa-field"><small>Razão social</small>${escapeHtml(contratada.razaoSocial||nomeEmpresa)}</div>
    <div class="empresa-field"><small>CNPJ</small>${escapeHtml(contratada.cnpj||'Não informado')}</div>
    <div class="empresa-field"><small>Contato</small>${escapeHtml(contatoEmpresa||'Não informado')}</div>
    <div class="empresa-field" style="grid-column:1/-1"><small>Assinante da contratada</small>${escapeHtml(nomeRepresentanteContratada?`${nomeRepresentanteContratada} · ${cargoRepresentanteContratada}`:'Não informado')}</div>
    <div class="empresa-field" style="grid-column:1/-1"><small>Endereço empresarial</small>${escapeHtml(enderecoEmpresa||'Não informado')}</div>
  </div>
</section>

<div class="partes">
  <div>
    <div class="parte-label">Contratante</div>
    <div class="parte-nome">${contratante.nome}</div>
    <div class="parte-info">
      ${contratante.cpf?`CPF: ${contratante.cpf}`:''}${contratante.estadoCivil?`, ${contratante.estadoCivil}`:''}, ${contratante.nacionalidade||'brasileiro(a)'}
      ${(()=>{if(!contratante.docTipo)return '';const n=contratante.docNumero?` nº ${contratante.docNumero}`:'';const arq=contratante.docAnexo?' (cópia digital arquivada)':'';return `<br>Doc. de identificação: ${contratante.docTipo}${n}${arq}`;})()}
      ${contratante.enderecoCompleto?`<br>${contratante.enderecoCompleto}`:''}
      ${contratante.bairro||contratante.cidade?`<br>${[contratante.bairro,contratante.cidade,contratante.cep].filter(Boolean).join(' · ')}`:''}
      ${contratante.email?`<br>${contratante.email}`:''}
    </div>
  </div>
  <div>
    <div class="parte-label">Contratada</div>
    <div class="parte-nome">${nomeEmpresa.toUpperCase()}</div>
    <div class="parte-info">
      ${contratada.cnpj?`CNPJ: ${contratada.cnpj}`:''}
      ${contratada.endereco?`<br>${contratada.endereco}`:''}
      ${contratada.tel?`<br>${telefoneContrato(contratada.tel)}`:''}
      ${nomeRepresentanteContratada?`<br>Representada por: ${escapeHtml(nomeRepresentanteContratada)}${cargoRepresentanteContratada?` — ${escapeHtml(cargoRepresentanteContratada)}`:''}`:''}
    </div>
  </div>
</div>

<div class="clausula">
<h3>1. Objeto e Escopo Contratado</h3>
<p>a. A CONTRATADA fornecerá material, realizará medição técnica, corte, beneficiamento, acabamento, furação, recortes, transporte e instalação das peças descritas na ${propostaRef}, respeitadas as inclusões, exclusões e condições expressamente registradas neste contrato, compreendendo:</p>
<ol>
<li>medição técnica no local;</li>
<li>fornecimento de pedra, chapa, cuba, acessórios ou demais materiais, quando expressamente previstos;</li>
<li>corte, acabamento, polimento, furação, recortes e beneficiamento das peças;</li>
<li>transporte das peças até o local da obra;</li>
<li>instalação das peças no imóvel indicado pela CONTRATANTE;</li>
<li>demais serviços descritos na proposta, neste contrato ou em documento técnico posterior aprovado.</li>
</ol>
<p>b. Qualquer item não previsto na proposta, neste contrato ou em documento posterior aprovado será considerado serviço adicional e dependerá de prévia definição técnica e comercial.</p>
</div>

<div class="clausula">
<h3>2. Documentos Integrantes e Ordem de Prevalência</h3>
<p>a. Na data da assinatura, integra este contrato a ${propostaRef}.</p>
<p>b. Após a medição, será emitido o documento único denominado "Levantamento Técnico Final e Autorização para Produção", que reunirá as informações tecnicamente verificáveis, o croqui executivo e a aprovação do CONTRATANTE. Depois de aprovado, esse documento integrará automaticamente a contratação.</p>
<p>c. Em caso de divergência, prevalecerá o documento posterior expressamente aprovado pelas partes, limitado à matéria que ele modificar e preservados os direitos obrigatórios do consumidor.</p>
<p>d. As condições de pagamento deste contrato refletem o alinhamento comercial posterior à proposta e prevalecem exclusivamente quanto ao preço, vencimentos e meios de pagamento.</p>
</div>

<div class="clausula">
<h3>3. Medição, Levantamento Técnico e Autorização para Produção</h3>
<p>a. As medidas constantes da proposta são preliminares quando fornecidas pelo cliente, arquiteto, marceneiro ou terceiro. A fabricação dependerá da medição técnica realizada ou validada pela CONTRATADA${contratuais.prazoMedicao?`, prevista para ocorrer em ${contratuais.prazoMedicao} a partir do cumprimento das condições de início`:''}.</p>
<p>b. O "Levantamento Técnico Final e Autorização para Produção" poderá conter: medidas definitivas, peças, espessuras, bordas, saias, espelhos, frontões, laterais, rodabancas, recortes, furos, acessórios de referência, condições das bases, observações e croquis executivos.</p>
<p>c. O documento será enviado ao WhatsApp cadastrado do CONTRATANTE, por link individual de conferência e aprovação. O sistema registrará a versão aprovada, a identidade do aprovador, o número de telefone, a data, o horário e a trilha de auditoria disponível.</p>
<p>d. A produção somente começará após o pagamento inicial, a conclusão da medição, a aprovação do documento técnico e o cumprimento das demais condições de início previstas neste contrato.</p>
<p>e. Diferenças técnicas encontradas na medição que alterem quantidade, dimensão, material, preço ou prazo serão apresentadas no próprio documento técnico ou em resumo comercial complementar. Nenhuma alteração será executada sem aceite expresso.</p>
<p>f. Após a aprovação, a versão será bloqueada. Eventual correção ou modificação produzirá nova versão, sem exclusão do histórico anterior.</p>
</div>

<div class="clausula">
<h3>4. Materiais, Fornecedores, Amostras e Características</h3>
<p>a. Os materiais e serviços contratados são os seguintes, por ambiente:</p>
<ol>
${(materiais.porAmbiente&&materiais.porAmbiente.length?materiais.porAmbiente:[{ambiente:'Conforme orçamento',material:'Conforme catálogo',espessura:'2 cm',acabamento:'polido',borda:'reta simples'}]).map(r=>`<li><strong>${r.ambiente||'Conforme orçamento'}</strong>: ${r.material||'Conforme catálogo'} — espessura ${r.espessura}, acabamento ${r.acabamento}, borda ${r.borda}</li>`).join('')}
${materiais.saias&&materiais.saias.length?`<li>Saias e frontão inclusos: <strong>${materiais.saias.join(', ')}</strong></li>`:''}
${materiais.areaMolhada?`<li>Área molhada: <strong>Sim — pingadeira, vedação e caimento conforme possibilidade técnica</strong></li>`:''}
${materiais.recortes&&materiais.recortes.length?`<li>Recortes e furos: <strong>${materiais.recortes.join(', ')}</strong></li>`:''}
<li>Suporte/estrutura: <strong>${materiais.suporte||'Conforme projeto'}</strong></li>
</ol>
<p>b. Fornecimento de acessórios:</p>
<ol>
<li>Cuba/tanque: <strong>${materiais.cuba}</strong></li>
<li>Ralo/válvula: <strong>${materiais.ralo||'responsabilidade do CONTRATANTE'}</strong></li>
<li>Sifão: <strong>${materiais.sifao||'responsabilidade do CONTRATANTE'}</strong></li>
<li>Torneira/misturador: <strong>${materiais.torneira||'responsabilidade do CONTRATANTE'}</strong></li>
</ol>
<p>c. O fornecedor ou distribuidor será selecionado pela CONTRATADA conforme disponibilidade comercial, qualidade e compatibilidade técnica. Salvo indicação expressa, a identidade do fornecedor não constitui condição essencial da contratação. Sobras e recortes residuais permanecem com a CONTRATADA, salvo ajuste escrito em sentido diverso.</p>
${materiais.obsMateria?`<p>d. Observações específicas: ${materiais.obsMateria}</p>`:''}
<p>${materiais.obsMateria?'e':'d'}. A CONTRATANTE declara estar ciente de que pedras naturais podem apresentar variações de tonalidade, veios, manchas naturais, cristalizações, porosidade, microfissuras e diferenças de desenho entre amostra e chapa. Materiais industrializados podem apresentar variações admissíveis entre lotes. Tais variações são intrínsecas ao material e, quando compatíveis com sua natureza, não configuram defeito.</p>
<p>${materiais.obsMateria?'f':'e'}. Não estão inclusos, salvo previsão expressa neste contrato: torneiras, sifões, ralos, válvulas, cooktops, trituradores, instalação hidráulica ou elétrica, marcenaria, alvenaria, pintura, remoção de peças existentes, descarte de entulho ou acabamentos civis.${inclusos}</p>
</div>

<div class="clausula">
<h3>5. Preço e Condições de Pagamento</h3>
<p>a. Pela execução dos serviços e fornecimento dos materiais, a CONTRATANTE pagará à CONTRATADA o valor total de <strong>${fmt2(financeiro.valor)}</strong>.</p>
<p>b. Forma de pagamento:</p>
${financeiro.saldo<=0.01?`<ol>
<li>Pagamento integral no ato da contratação/pedido: <strong>${fmt2(financeiro.entrada||financeiro.valor)}</strong> (100% do valor total) ${financeiro.pagtoEntrada?`— via ${financeiro.pagtoEntrada}`:''}.</li>
</ol>
<p>c. A confirmação do pagamento ocorrerá somente após a efetiva compensação. A produção somente terá início após a confirmação do pagamento integral, a conclusão da medição e a aprovação do documento técnico.</p>`:`<ol>
<li>Sinal/entrada: <strong>${fmt2(financeiro.entrada)}</strong> (${pctEntrada}% do valor total) ${financeiro.pagtoEntrada?`— via ${financeiro.pagtoEntrada}`:''};</li>
<li>Saldo final: <strong>${fmt2(financeiro.saldo)}</strong> até ${financeiro.prazoSaldo||'5'} dias antes da entrega ${financeiro.pagtoSaldo?`— via ${financeiro.pagtoSaldo}`:''}.</li>
</ol>
<p>c. A confirmação do pagamento ocorrerá somente após a efetiva compensação. A produção somente terá início após o pagamento do sinal, a conclusão da medição e a aprovação do documento técnico.</p>`}
<p>d. Em caso de atraso no pagamento: multa de 2% sobre a parcela vencida, juros de 1% ao mês, calculados proporcionalmente, e atualização monetária pelo IPCA, observada a legislação aplicável. A produção poderá ser suspensa enquanto houver parcela vencida, sem caracterizar atraso da CONTRATADA.</p>
</div>

<div class="clausula">
<h3>6. Prazo, Termo Inicial e Programação</h3>
<p>a. O prazo estimado para fabricação e instalação é de <strong>${prazo.dias||'30'} dias úteis</strong>, contado a partir de ${prazo.base}.</p>
<p>b. Constituem condições de início: pagamento da entrada; medição concluída; aprovação técnica; material aprovado e disponível; entrega de cubas, cooktops, torneiras e gabaritos necessários; bases, marcenaria e alvenaria concluídas; local liberado; e autorizações do condomínio disponíveis.</p>
${(contratuais.prazoMedicao||contratuais.prazoProducao)?`<p>c. Previsão interna: medição ${contratuais.prazoMedicao?`em ${contratuais.prazoMedicao}`:'conforme agenda'}; produção ${contratuais.prazoProducao?`em ${contratuais.prazoProducao}`:'conforme agenda'}; instalação conforme agenda confirmada, sem alteração do prazo global salvo ajuste expresso.</p>`:''}
<p>${(contratuais.prazoMedicao||contratuais.prazoProducao)?'d':'c'}. O prazo será prorrogado pelo período do impedimento quando houver atraso do cliente, mudança de escopo, indisponibilidade superveniente de material, impedimento de acesso, correção de bases, caso fortuito, força maior ou evento comprovadamente alheio ao controle da CONTRATADA.</p>
</div>

<div class="clausula">
<h3>7. Condições do Local, Nova Visita e Remobilização</h3>
<p>a. O local deverá estar livre, limpo, acessível e com marcenaria, bases, alvenaria, pisos, paredes, pontos hidráulicos e estruturas finalizados, estáveis e nivelados, conforme a etapa do serviço.</p>
<p>b. A CONTRATADA poderá suspender a medição ou instalação quando identificar condição insegura ou incompatível, registrando o impedimento no histórico do pedido.</p>
<p>c. Quando o local não estiver apto na data agendada, será aplicada taxa de nova visita de <strong>${fmt2(contratuais.taxaNovaVisita)}</strong>${contratuais.taxaRemobilizacao?` e, quando houver equipe, veículo ou peças mobilizadas, taxa de remobilização de <strong>${fmt2(contratuais.taxaRemobilizacao)}</strong>`:''}, sem prejuízo de despesas extraordinárias previamente aprovadas. Não será aplicada taxa causada por erro comprovado da CONTRATADA.</p>
<p>d. A nova data será definida após a regularização${contratuais.prazoReagendamento?`, com prazo de reagendamento de ${contratuais.prazoReagendamento}`:''}, conforme disponibilidade operacional.</p>
</div>

<div class="clausula">
<h3>8. Itens Fornecidos pelo Contratante</h3>
<p>a. Cubas, tanques, cooktops, torneiras, dosadores, filtros e acessórios de responsabilidade do CONTRATANTE deverão ser entregues no prazo solicitado, em perfeitas condições e com gabaritos ou manuais aplicáveis.</p>
<p>b. A ausência, incompatibilidade ou alteração de modelo poderá suspender a medição, o corte ou a instalação e gerar nova programação, mediante aprovação. A CONTRATADA não responde por defeito de fabricação ou garantia dos itens fornecidos pelo CONTRATANTE.</p>
</div>

<div class="clausula">
<h3>9. Apoios, Chumbadores e Elementos de Fixação</h3>
<p>a. Quando previstos no escopo, chumbadores, fixadores e elementos de ancoragem serão fornecidos pela CONTRATADA. Tipo, dimensão, quantidade e método dependem da base, carga, vão, balanço e acesso.</p>
<p>b. Poderão ser empregados componentes tecnicamente equivalentes, desde que não haja redução de segurança, desempenho ou durabilidade. A CONTRATADA não assume a capacidade estrutural de bases executadas por terceiros e poderá recusar fixação em substrato inadequado até sua correção.</p>
</div>

<div class="clausula">
<h3>10. Transporte, Acesso Especial e Içamento</h3>
<p>a. Modalidade contratada: <strong>${local.instalacao||'fornecimento, transporte e instalação'}</strong>.</p>
<p>b. Endereço de instalação: <strong>${enderecoInstalacao||'A confirmar'}</strong>${local.andar?` — ${local.andar}`:''}${local.condominio?`, ${local.condominio}`:''}.</p>
<p>c. Içamento / acesso especial: <strong>${local.icamento||'a confirmar após verificação de acesso'}</strong>. Não estão inclusos, salvo previsão expressa: guindaste, munck, plataforma elevatória, içamento por fachada, desmontagens, proteção especial de áreas comuns, licenças, ART/RRT, taxas condominiais e serviços de terceiros. Quando necessários, esses custos dependerão de orçamento e pagamento prévios, e a instalação poderá permanecer suspensa até sua contratação.</p>
<p>d. Serviços não contemplados: instalação hidráulica/elétrica, alvenaria, marcenaria, pintura, remoção de peças existentes e descarte de entulho.</p>
</div>

<div class="clausula">
<h3>11. Execução, Tolerâncias, Emendas e Limitações Técnicas</h3>
<p>a. As peças serão executadas conforme as condições reais da obra e as boas práticas técnicas compatíveis com o material. Pequenas variações decorrentes de corte, polimento, esquadro, prumo, nível, paredes, pisos, móveis e juntas são admissíveis quando não comprometem segurança, uso, desempenho ou acabamento esperado.</p>
<p>b. Emendas poderão ser necessárias por limitação da chapa, dimensões, transporte, acesso, estabilidade ou segurança. Quando verificáveis antes do corte, serão indicadas no documento técnico.</p>
<p>c. A CONTRATADA não assume responsabilidade por infiltrações, vazamentos, umidade, desníveis ou problemas hidráulicos e elétricos preexistentes, e poderá interromper serviço que represente risco às pessoas, às peças ou ao imóvel.</p>
</div>

<div class="clausula">
<h3>12. Obrigações da Contratada</h3>
<ol>
<li>Executar os serviços conforme os documentos aprovados e as condições contratadas;</li>
<li>Realizar medição técnica, beneficiar, transportar e instalar as peças;</li>
<li>Empregar mão de obra e ferramentas compatíveis com o serviço;</li>
<li>Informar limitações técnicas e impedimentos relevantes identificados durante a execução;</li>
<li>Proteger razoavelmente a área imediata de trabalho e remover resíduos diretamente produzidos por sua atividade;</li>
<li>Corrigir vícios de material, fabricação ou instalação que sejam de sua responsabilidade, observadas as regras de garantia.</li>
</ol>
</div>

<div class="clausula">
<h3>13. Obrigações da Contratante</h3>
<ol>
<li>Fornecer informações corretas e completas sobre o local, o projeto e os equipamentos;</li>
<li>Conferir e aprovar proposta, material, levantamento técnico, croquis e alterações antes da produção;</li>
<li>Garantir acesso ao imóvel, disponibilidade de responsável e cumprimento das regras do condomínio;</li>
<li>Manter o local apto, seguro e liberado nas datas combinadas;</li>
<li>Disponibilizar os itens de sua responsabilidade e comunicar qualquer alteração antes do corte;</li>
<li>Efetuar os pagamentos nos prazos contratados;</li>
<li>Impedir intervenções de terceiros nas peças e fixações até a cura dos produtos e a liberação técnica da CONTRATADA;</li>
<li>Garantir a autenticidade, veracidade e titularidade de todos os documentos e informações fornecidos à CONTRATADA para elaboração deste instrumento, respondendo civil e criminalmente por eventuais falsidades (art. 299 do Código Penal; art. 186 do Código Civil);</li>
${contratante.docAnexo?`<li>O(A) CONTRATANTE declara expressamente que o documento de identificação encaminhado por meio eletrônico (${contratante.docTipo||'documento de identificação'}${contratante.docNumero?' nº '+contratante.docNumero:''}) é legítimo, íntegro e pertencente ao próprio signatário, cuja cópia digital foi arquivada pela CONTRATADA como parte integrante deste contrato, com validade probatória nos termos da MP 2.200-2/2001 e Lei 14.063/2020.</li>`:''}
</ol>
</div>

<div class="clausula">
<h3>14. Modificações Solicitadas após a Contratação</h3>
<p>a. Modificação solicitada pelo CONTRATANTE após a assinatura ou após a aprovação técnica será registrada no histórico do pedido, com identificação do solicitante, data, canal, conteúdo anterior, nova condição e impactos conhecidos.</p>
<p>b. Quando a modificação afetar preço, prazo, medida, material, recorte, acabamento, estrutura, instalação ou escopo, será gerada Ordem de Alteração para aprovação eletrônica antes da execução. Alterações não aprovadas permanecerão sem efeito.</p>
<p>c. Peças já cortadas, beneficiadas ou personalizadas poderão não admitir alteração. Quando tecnicamente possível, o custo de refazimento, material e reprogramação será apresentado previamente. Peças já cortadas ou beneficiadas não poderão ser canceladas sem pagamento de 85% do valor correspondente aos custos incorridos.</p>
</div>

<div class="clausula">
<h3>15. Entrega, Instalação e Termo de Conclusão</h3>
<p>a. Ao final de cada entrega parcial ou da instalação final, a CONTRATADA poderá gerar o "Termo de Entrega e Instalação", contendo as peças executadas, o status da instalação, ressalvas, pendências, prazos de correção e o início da garantia.</p>
<p>b. O termo será encaminhado ao WhatsApp cadastrado para ciência e aprovação eletrônica, com registro da versão e da trilha de auditoria.</p>
<p>c. Pendência pontual será registrada e não descaracterizará a entrega das demais peças corretamente executadas. O aceite não representa renúncia a direitos relativos a vícios ocultos ou garantias obrigatórias.</p>
</div>

<div class="clausula">
<h3>16. Garantia, Assistência e Conservação</h3>
<p>a. A CONTRATADA observará a garantia legal aplicável aos produtos e serviços duráveis.${garantiaAdicional}</p>
<p>b. A garantia abrangerá vícios de material fornecido pela CONTRATADA, beneficiamento, acabamento, recortes, colagens, instalação e fixações que sejam comprovadamente de sua responsabilidade. Não são cobertos danos decorrentes de impacto, mau uso, calor excessivo, produtos inadequados, movimentação estrutural, infiltração, vazamento, sobrecarga, intervenção de terceiros ou falta de manutenção.</p>
<p>c. A comunicação de assistência deverá ser feita pelo canal <strong>${canalAssistencia}</strong>, acompanhada de descrição e, quando possível, fotografias. A CONTRATADA agendará avaliação antes de reconhecer causa, cobertura ou solução.</p>
</div>

<div class="clausula">
<h3>17. Cancelamento e Rescisão</h3>
<p>a. Antes do corte, serão descontados apenas os valores correspondentes às atividades e despesas já realizadas. Após corte ou beneficiamento, serão devidos os custos do material personalizado e dos serviços executados, até o limite de 85% do valor correspondente.</p>
<p>b. A CONTRATADA poderá rescindir o contrato por inadimplência relevante, impossibilidade técnica não solucionada, impedimento de acesso ou descumprimento persistente do CONTRATANTE, após comunicação e oportunidade razoável de regularização.</p>
<p>c. Inadimplência superior a 30 dias autoriza suspensão dos serviços e rescisão.</p>
</div>

<div class="clausula">
<h3>18. Impedimentos, Atrasos e Caso Fortuito</h3>
<p>a. Não será considerado atraso da CONTRATADA o período decorrente de pagamento pendente, ausência de aprovação, falta de material ou equipamento do cliente, obra não liberada, restrição condominial, alteração de projeto, correção de base ou evento comprovadamente alheio ao seu controle.</p>
<p>b. A indisponibilidade definitiva do material contratado permitirá oferecer opção equivalente para aprovação. Não sendo aceita alternativa tecnicamente adequada, as partes ajustarão a substituição, a espera ou o encerramento da parte afetada, com devolução do valor não executado.</p>
</div>

<div class="clausula">
<h3>19. Condições Preexistentes e Registro Informativo</h3>
<p>a. A verificação da CONTRATADA possui caráter visual e informativo e não constitui perícia estrutural, hidráulica, elétrica ou de impermeabilização.</p>
<p>b. Irregularidades aparentes relevantes, como trincas, infiltrações, avarias, bases instáveis ou acessos de risco, poderão ser comunicadas e registradas no histórico do pedido, inclusive por fotografias quando necessário. A ausência de registro fotográfico não transfere à CONTRATADA responsabilidade por vício preexistente cuja causa seja comprovadamente alheia ao serviço contratado.</p>
</div>

<div class="clausula">
<h3>20. Proteção de Dados e Uso de Imagens</h3>
<p>a. Os dados pessoais serão tratados para cadastro, elaboração da proposta e do contrato, execução, comunicação, cobrança, garantia e cumprimento de obrigações legais (LGPD).</p>
<p>b. O uso de fotografias ou vídeos para portfólio, publicidade ou redes sociais dependerá de autorização separada, específica e facultativa, cuja recusa não afetará a prestação dos serviços.</p>
</div>

<div class="clausula">
<h3>21. Comunicações, Aprovações e Assinatura Eletrônica</h3>
<p>a. Serão válidas as comunicações enviadas aos e-mails e números de WhatsApp indicados na qualificação, cabendo a cada parte informar eventual alteração.</p>
<p>b. Propostas, documentos técnicos, ordens de alteração, termos de entrega e demais aprovações poderão ser encaminhados por link individual enviado via WhatsApp ou e-mail. A aprovação eletrônica produzirá efeitos quando vinculada à versão do documento e acompanhada dos registros disponíveis de identidade, telefone, data, horário e trilha de auditoria.</p>
<p>c. As partes reconhecem a validade das assinaturas eletrônicas admitidas em lei, nos termos da MP 2.200-2/2001 e Lei 14.063/2020, dispensando reconhecimento de firma em cartório.</p>
</div>

<div class="clausula">
<h3>22. Disposições Gerais e Foro</h3>
<p>a. A tolerância eventual de uma parte não importará novação, renúncia ou alteração permanente do contrato.</p>
<p>b. A invalidade de uma disposição não prejudicará as demais, devendo as partes substituí-la por regra válida que preserve, na maior medida possível, sua finalidade legítima.</p>
<p>c. Fica eleito o foro da comarca de <strong>${comarcaForo}</strong>, quando legalmente admissível, preservado ao consumidor o direito de utilizar o foro de seu domicílio nos casos previstos em lei.</p>
</div>
${obsAdicionais}

<div class="clausula" style="margin-top:28px;text-align:center;font-size:13px;color:#444">
${cidadeContrato||'Campinas'}, ${dataContrato||new Date().toLocaleDateString('pt-BR',{day:'numeric',month:'long',year:'numeric'})}
</div>

<div class="assinaturas">
  <div class="assin-bloco">
    <div class="assin-linha">
      <strong>CONTRATANTE</strong><br>
      ${contratante.nome}<br>
      ${contratante.cpf?`CPF: ${contratante.cpf}`:''}
    </div>
  </div>
  <div class="assin-bloco">
    <div class="assin-linha">
      <strong>CONTRATADA</strong><br>
      ${escapeHtml(nomeRepresentanteContratada||nomeEmpresa.toUpperCase())}<br>
      ${nomeRepresentanteContratada?`${escapeHtml(cargoRepresentanteContratada)}<br>`:''}
      ${nomeEmpresa.toUpperCase()}<br>
      ${contratada.cnpj?`CNPJ: ${contratada.cnpj}`:''}
    </div>
  </div>
</div>

<div class="plataforma-final">${escapeHtml(CONTRATO_RODAPE_PLATAFORMA)}</div>
</main>
</body></html>`;
}

function _coletarDadosContrato(){
  const cfg=configEmpresaNormalizada(CACHE.config||{});
  const docIdentity=identidadeDocumentoTenant(cfg);
  const org=organizacaoAtiva();
  const valorDaPlataforma=v=>/gaturamo/i.test(String(v||''));
  const nomeDoc=docIdentity.displayName||docIdentity.nomeFantasia||docIdentity.razaoSocial||cfg.nome;
  const nomeContratada=valorDaPlataforma(nomeDoc)?(org.nomeFantasia||EMPRESA_NOME_PADRAO):(nomeDoc||org.nomeFantasia||EMPRESA_NOME_PADRAO);
  const representanteContratada=docIdentity.representante||cfg.representante||org.representante||{};
  const pedidoId=document.getElementById('ct-pedido-id')?.value;
  const p=pedidoId?(DB.get('pedidos').find(x=>x.id===pedidoId)||{}):{};
  return {
    proposta:{
      numero:p.num||'',
      data:p.data?new Date(p.data+'T12:00').toLocaleDateString('pt-BR'):'',
      versao:String(Number(p.versaoOrcamento)||1).padStart(2,'0'),
    },
    contratuais:{
      comarcaForo:cfg.comarcaForo||'Campinas/SP',
      garantiaContratual:cfg.garantiaContratual||'',
      canalAssistencia:cfg.canalAssistencia||cfg.tel||cfg.email||'',
      taxaNovaVisita:cfg.taxaNovaVisita!=null&&cfg.taxaNovaVisita!==''?cfg.taxaNovaVisita:250,
      taxaRemobilizacao:cfg.taxaRemobilizacao||0,
      prazoReagendamento:cfg.prazoReagendamento||'',
      prazoMedicao:cfg.prazoMedicao||'',
      prazoProducao:cfg.prazoProducao||'',
    },
    contratante:{
      nome:document.getElementById('ct-nome').value.trim(),
      cpf:document.getElementById('ct-cpf').value.trim(),
      legacyRg:normalizarRgLegado(document.getElementById('ct-rg').value.trim(),'contrato'),
      estadoCivil:document.getElementById('ct-estado-civil').value,
      nacionalidade:document.getElementById('ct-nacionalidade').value,
      email:document.getElementById('ct-email').value.trim(),
      enderecoCompleto:[document.getElementById('ct-end-rua').value.trim(),document.getElementById('ct-end-numero').value.trim(),document.getElementById('ct-end-complemento').value.trim()].filter(Boolean).join(', '),
      bairro:document.getElementById('ct-end-bairro').value.trim(),
      cidade:document.getElementById('ct-end-cidade').value.trim(),
      cep:document.getElementById('ct-end-cep').value.trim(),
      docTipo:document.getElementById('ct-doc-tipo')?.value||'',
      docNumero:document.getElementById('ct-doc-numero')?.value.trim()||'',
      docAnexo:window._ctDocDataUrl?document.getElementById('ct-doc-nome')?.textContent||'':''  ,
    },
    contratada:{
      nome:nomeContratada,
      nomeFantasia:nomeContratada,
      razaoSocial:valorDaPlataforma(docIdentity.razaoSocial)?nomeContratada:(docIdentity.razaoSocial||nomeContratada),
      cnpj:docIdentity.cnpj||cfg.cnpj||org.cnpj||'',
      endereco:cfg.endereco||'',
      tel:cfg.tel||'',
      email:cfg.email||'',
      cidade:cfg.cidade||'',
      logoUrl:normalizarLogoEmpresa(docIdentity.logoUrl||cfg.logoUrl)||EMPRESA_LOGO_PADRAO,
      representante:{
        nome:representanteContratada.nome||'',
        cargo:representanteContratada.cargo||'Representante legal',
        assinaContratada:representanteContratada.assinaContratada!==false
      },
    },
    materiais:{
      porAmbiente:_ctMateriais.map(r=>({ambiente:r.ambiente||'',material:r.material||'',espessura:r.espessura||'2 cm',acabamento:r.acabamento||'polido',borda:r.borda||'reta simples'})).filter(r=>r.ambiente||r.material),
      saias:(()=>{
        const items=[];
        const chk=(id,label,altId)=>{if(document.getElementById(id)?.checked){const h=document.getElementById(altId)?.value;items.push(label+(h?` (${h} cm)`:'')); } };
        chk('ct-saia-frontal','Saia frontal','ct-saia-frontal-alt');
        chk('ct-saia-lateral','Saia lateral','ct-saia-lateral-alt');
        chk('ct-frontao','Frontão','ct-frontao-alt');
        chk('ct-rodaborda','Rodaborda','ct-rodaborda-alt');
        chk('ct-espelho','Espelho','ct-espelho-alt');
        return items;
      })(),
      areaMolhada:document.getElementById('ct-area-molhada')?.checked||false,
      recortes:(()=>{
        const items=[];
        const chk=(id,label)=>{if(document.getElementById(id)?.checked)items.push(label);};
        chk('ct-recorte-cuba','Recorte de cuba');
        chk('ct-recorte-cooktop','Recorte de cooktop');
        chk('ct-furo-torneira','Furo para torneira');
        chk('ct-furo-filtro','Furo para filtro');
        chk('ct-furo-dosador','Furo para dosador');
        chk('ct-recorte-lixeira','Recorte de lixeira embutida');
        chk('ct-canal-molhado','Canal molhado');
        chk('ct-escorredor','Escorredor usinado');
        return items;
      })(),
      cuba:document.getElementById('ct-cuba').value,
      ralo:document.getElementById('ct-ralo').value,
      sifao:document.getElementById('ct-sifao').value,
      torneira:document.getElementById('ct-torneira').value,
      suporte:document.getElementById('ct-suporte').value,
      obsMateria:document.getElementById('ct-obs-material').value.trim(),
    },
    financeiro:{
      valor:parseFloat(document.getElementById('ct-valor').value)||0,
      entrada:parseFloat(document.getElementById('ct-entrada').value)||0,
      saldo:parseFloat(document.getElementById('ct-saldo').value)||0,
      pagtoEntrada:document.getElementById('ct-pagto-entrada').value.trim(),
      pagtoSaldo:document.getElementById('ct-pagto-saldo').value.trim(),
      prazoSaldo:document.getElementById('ct-pagto-prazo').value||'5',
    },
    prazo:{
      dias:document.getElementById('ct-prazo-dias').value||'30',
      base:document.getElementById('ct-prazo-base').value,
    },
    local:{
      enderecoObra:document.getElementById('ct-end-obra').value.trim(),
      andar:document.getElementById('ct-end-andar').value.trim(),
      condominio:document.getElementById('ct-condominio').value.trim(),
      instalacao:document.getElementById('ct-instalacao').value,
      icamento:document.getElementById('ct-icamento').value,
    },
    adicionais:{
      texto:document.getElementById('ct-obs-adicionais').value.trim(),
      inclusos:document.getElementById('ct-inclusos').value.trim(),
    },
    dataContrato:document.getElementById('ct-data-contrato').value?new Date(document.getElementById('ct-data-contrato').value+'T12:00').toLocaleDateString('pt-BR',{day:'numeric',month:'long',year:'numeric'}):'',
    cidadeContrato:document.getElementById('ct-cidade-contrato').value.trim(),
  };
}

async function buscarCepContrato(cep){
  const c=cep.replace(/\D/g,'');
  if(c.length!==8)return;
  const spin=document.getElementById('ct-cep-buscando');
  if(spin)spin.style.display='inline';
  try{
    const res=await fetch(`https://viacep.com.br/ws/${c}/json/`);
    const data=await res.json();
    if(data.erro){toast('CEP não encontrado','warn');return;}
    const rua=document.getElementById('ct-end-rua');
    const bairro=document.getElementById('ct-end-bairro');
    const cidade=document.getElementById('ct-end-cidade');
    if(rua&&!rua.value)rua.value=data.logradouro||'';
    if(bairro&&!bairro.value)bairro.value=data.bairro||'';
    if(cidade&&!cidade.value)cidade.value=`${data.localidade}/${data.uf}`;
  }catch(e){toast('Erro ao buscar CEP','warn');}
  finally{if(spin)spin.style.display='none';}
}

